import { ImageProps } from '@/components/common/Image';

/**
 * Default configuration for Image component fallback behavior
 */
export const IMAGE_DEFAULTS: Partial<ImageProps> = {
  hideOnError: false,
  showPlaceholder: true,
  retryOnError: true,
  retryDelay: 1000,
  maxRetries: 2,
  showLoadingState: false,
};

/**
 * Placeholder class configurations for different image types
 */
export const IMAGE_PLACEHOLDER_CLASSES = {
  hero: 'aspect-[16/9] w-full',
  card: 'aspect-square w-full',
  thumbnail: 'aspect-[4/3] w-full',
  avatar: 'aspect-square rounded-full',
  banner: 'aspect-[21/9] w-full',
} as const;

/**
 * Default placeholder colors for different contexts
 */
export const IMAGE_PLACEHOLDER_COLORS = {
  primary: 'bg-gray-100',
  secondary: 'bg-gray-50',
  dark: 'bg-gray-800',
} as const;